import axios from 'axios'
import QS from 'qs'
axios.defaults.timeout = 100000;
axios.defaults.baseURL ='';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';



//post请求
export function post(url,data){
    return new Promise((resolve,reject) => {
        // window.console.log('url=========',url);
        // window.console.log('params=========',data);
        data.entry_type = 'web';
        // data.user_type = this.$store.state.user_type;
        axios.post(url,QS.stringify(data))
            .then(response => {
                if(response.data.code === 10000){
                    resolve(response.data);
                }else{
                    reject(response.data)
                }

            },err => {
                reject(err)
            })
    })
}
